<template>
  <div class="emai-register-wrapper">
    <div class="stepOneRegister">
      <div class="account-form">
        <div class="form-row email-input">
            <input class="form-input" type="email" name="userName" v-model="email" :placeholder="$t('register.email')">
            <p class="text-error">{{ $t(emailError) }}</p>
        </div>
        <div class="form-row">
            <input class="form-input code-input" type="text" name="code" v-model="code" :placeholder="$t('register.code')">
            <img class="send-code-btn" :src="randomCode" alt=""  @click="updateCode">
            <p class="text-error">{{ $t(codeError) }}</p>
        </div>
        <div class="form-row">
            <input class="form-input" type="password" name="password" v-model="password" :placeholder="$t('register.password_set')" @keyup.enter="save">
            <p class="text-error">{{ $t(passwordError) }}</p>
        </div>
        <div class="form-row">
          <country-com :lang="lang" v-model:countryInfo="countryInfo"/>
        </div>
        <div class="checkbox-wapper">
          <span v-on:click="alocked" class="checkbox"><i class="icon-box iconfont" v-if="!checked"></i><i class="icon-checked iconfont" v-else></i></span>
          <span style="color: #cccccc">{{ $t('register.protocol_a') }}<span class="checkbox-text" @click="registerService" style="color: #272f44">{{ $t('register.protocol_b') }}</span></span>
        </div>
        <div class="form-row">
          <button @click="save" v-bind:class="{ 'save-phone-btn': checked, 'no-save-phone-btn': !checked }" v-bind:disabled="!checked">{{ $t('register.submit') }}</button>
        </div>
        <div class="form-row login">
          <p><span class="login-btn" @click="gotoLogin">{{ $t('register.login_now') }} <span class="iconfont icon-login-right"></span></span></p>
        </div>
      </div>
    </div>
    <loading :appear="processing"></loading>
  </div>
</template>

<script>
import Config from 'common/script/config.js'
import Validate from 'common/script/validate.js'
import MD5 from 'common/script/md5.js'
import loading from 'components/loading/loading'
import CountryCom from 'components/country/countryCom.vue'
export default {
  props: ['lang'],
  data () {
    return {
      account: '',
      password: '',
      code: '',
      randomCode: Config.passportHost + '/public/kaptcha?random=' + Math.random(),
      email: '',
      userID: '',
      emailError: '',
      codeError: '',
      passwordError: '',
      checked: true,
      processing: false,
      countryInfo: {}
    }
  },
  components: {
    loading,
    CountryCom
  },
  methods: {
    registerService: function () {
      window.open('protocol.html')
    },
    gotoLogin: function () {
      window.location.href = 'index.html'
    },
    gotoActivation: function () {
      window.location.href = 'activation.html?userID=' + this.userID
    },
    updateCode: function () {
      this.randomCode = Config.passportHost + '/public/kaptcha?random=' + Math.random()
    },
    formCheck: function () {
      this.reset()
      var validate = true
      if (Validate.stringEmpty(this.email)) {
        this.emailError = 'register.email'
        validate = false
      }
      if (!Validate.validateEmail(this.email)) {
        this.emailError = 'register.email_error'
        validate = false
      }
      if (Validate.stringEmpty(this.password)) {
        this.passwordError = 'register.password_error_1'
        validate = false
      }
      if (!Validate.passwordRule(this.password)) {
        this.passwordError = 'register.password_set'
        validate = false
      }
      if (Validate.stringEmpty(this.code)) {
        this.codeError = 'register.error_code_1'
        validate = false
      }
      return validate
    },
    reset: function () {
      this.emailError = ''
      this.codeError = ''
      this.passwordError = ''
    },
    alocked: function () {
      this.checked = !this.checked
    },
    save: function () {
      if (this.formCheck()) {
        this.processing = true
        this.$http.post(Config.passportHost + '/public/web/register/email', {
          'email': this.email,
          'password': MD5.hex_md5(this.password),
          'kaptcha': this.code,
          'locale': Config.local4Service(),
          'countryCode': this.countryInfo.countryCode
        }).then((response) => {
          this.processing = false
          this.reset()
          response = response.body
          this.userID = response.body
          if (response.code === 1000) {
            this.gotoActivation()
          } else if (response.code === 1008) {
            this.emailError = 'register.email_error'
          } else if (response.code === 1011) {
            this.emailError = 'register.email_already_bound'
          } else if (response.code === 1040) {
            this.codeError = 'register.code_error'
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.emai-register-wrapper
  .account-form
    padding-top 0rem
    .form-row
    &.phone-input
      margin-top 0rem
      margin-bottom 0rem
      .text-error
        min-height 0.16rem
        line-height 0.16rem
      .code-input
        width 2.2rem
        height 0.3rem
      .send-code-btn
        float right
        min-width 0.77rem
        height 0.3rem
        margin-left 0.08rem
        line-height 0.3rem
        font-size 0.12rem
        cursor pointer
        width 0.77rem
        border-radius 0.04rem
      .no-save-phone-btn
        cursor default
        background-color #a9acb4
    .checkbox-wapper
      margin-top 0.32rem
      margin-bottom 0.08rem
      .checkbox-text, input
        cursor pointer
      .checkbox
        font-size 0.14rem
        cursor pointer
        color #272f44
        border-radius 0.04rem
    .login
      margin-top 0.16rem
      font-size 0.12rem
      .icon-login-right
        font-size 0.08rem
        color #979797
      .login-btn
        cursor pointer
  .active
    .icon-box:before
      content "\e908"
@media screen and (max-device-width: 720px), (max-width: 720px)
  .phone-number
    display inline-block
    width 2.684rem !important
  .account-form
    .form-row
      .code-input
        width 1.95rem !important
        height 0.44rem !important
      .send-code-btn
        float right
        margin-top 0.05rem !important
        min-width 1rem !important
        height 0.35rem !important
        line-height 0.35rem !important
        font-size 0.12rem !important
</style>



// WEBPACK FOOTER //
// emailRegister.vue?41fed946